import React, { useState } from 'react';
import { useMutation } from '@apollo/client';

import { AssignmentScoringContainer } from './assignment-scoring.container';
import { getIsSavingScores } from '../../_core/OfflineHandler/offline-handler.container';
import { getAuthUser } from '../../../lib/services/auth.service';
import { useCalibrationAssignment } from '../../../lib/services/calibration-assignment.service';
import { IRecordUserSessionData, useFlushScoresOnUnmount, useSubmitScores } from '../../../lib/services/score-submit.service';
import { RECORD_USER_SESSION } from '../../../lib/queries/user-session.queries';

interface IAssignmentScoringGraphQLProps {
  assignmentId: string;
}

export const AssignmentScoringGraphQL: React.FC<IAssignmentScoringGraphQLProps> = ({ assignmentId }) => {
  const [hasUnsavedScores, setHasUnsavedScores] = useState(false);
  const isSaving = getIsSavingScores();
  const user = getAuthUser();

  const { assignment, loading, fetchError, refetch } = useCalibrationAssignment(assignmentId);

  const [recordUserSessionActionMutation] = useMutation<IRecordUserSessionData>(RECORD_USER_SESSION);

  useFlushScoresOnUnmount(user, recordUserSessionActionMutation);
  const handleSubmitScores = useSubmitScores(user, recordUserSessionActionMutation, refetch, 'Failed submitting calibration scores');

  return (
    <AssignmentScoringContainer
      assignment={assignment}
      submitScores={handleSubmitScores}
      loading={loading}
      fetchError={fetchError}
      hasUnsavedScores={hasUnsavedScores}
      setHasUnsavedScores={setHasUnsavedScores}
      isSaving={isSaving}
    />
  );
};
